import styles from './Button.module.css';

function Button({ children, type = 'button', variant = 'primary', size = 'md', fullWidth = true, className = '', onClick, disabled, style }) {
  return (
    <button
      type={type}
      className={`${fullWidth ? 'btn w-100' : ''} ${styles.btn} ${styles[variant]} ${styles[size]} ${className}`}
      onClick={onClick}
      disabled={disabled}
      style={style}
    >
      {children}
    </button>
  );
}

export default Button;
